import { createStore, applyMiddleware } from 'redux';
import _mapValues from 'lodash/mapValues';
import reducers from '../reducers';
import firebaseMiddleware from '../middlewares/firebaseMiddleware';
import chatSdkMiddleware from '../middlewares/chatSdkMiddleware';
import thunk from 'redux-thunk';
import { ServerApi } from '../services/serverApi';
import { initVisitCount } from '../services/visitCount';

function deserializeExperiments(experiments) {
  return _mapValues(experiments, value =>
    value === 'true' ? true : value === 'false' ? false : value,
  );
}

//this will be unnecessary once visitCount.js is converted to TS
interface VisitCount {
  getVisitCount: Function;
  incVisitCount: Function;
}

export interface ThunkExtraArgument {
  visitCount: VisitCount;
  serverApi: ServerApi;
}

export default function configureStore({
  serverApi = null,
  experiments = {},
  ...initialState
}: any = {}) {
  const visitCount: VisitCount = initVisitCount();
  const middlewares = [
    thunk.withExtraArgument<ThunkExtraArgument>({ visitCount, serverApi }),
    firebaseMiddleware,
    chatSdkMiddleware,
  ];

  const newInitialState = {
    ...initialState,
    experimentsRaw: { ...experiments },
    experiments: deserializeExperiments(experiments),
  };

  return createStore(
    reducers,
    newInitialState,
    applyMiddleware(...middlewares),
  );
}
